import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import LinkHandler from '../link-handler';
import { breakpoint } from '../theme/breakpoint';
import { multiplyPx } from '../styled/utils';

const halfPx = multiplyPx(0.5);

export const BreadcrumbList = styled.ul`
  background: ${({ theme }) => theme.palette.white};
  margin: 0;
  padding: ${({ theme }) => theme.spacing.small} 0;
  display: flex;
  flex-wrap: wrap;
`;

export const BreadcrumbListItem = styled.li`
  color: ${({ theme }) => theme.palette.secondaryText};
  margin-bottom: 0;
  margin-right: ${({ theme }) => theme.spacing.tiny};
  align-items: center;
  display: none;
  margin-top: ${({ theme }) => halfPx(theme.spacing.tiny)};
  margin-bottom: ${({ theme }) => halfPx(theme.spacing.tiny)};

  // display only the immediate parent link on mobile and tablet
  &:nth-last-child(2) {
    display: flex;
  }

  ${breakpoint.desktop`
    display: flex;
    flex-direction: row-reverse;
  `}
`;

export const BreadcrumbAnchor = styled(LinkHandler)``;

export const ArrowSVG = styled(SVG)`
  color: ${({ theme }) => theme.palette.secondaryButton};
  margin-right: ${({ theme }) => theme.spacing.tiny};

  ${breakpoint.desktop`
    margin-right: 0;
    margin-left: ${({ theme }) => theme.spacing.tiny};
    transform: rotate(180deg);
  `}
`;
